import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Reset from '../views/Reset.vue'
import util from "@/util";

Vue.use(VueRouter)
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset,
    meta: {
      title: 'Reset Password'
    }
  },

  //{
  // path: '/demo',
  // name: 'Demo',
  // component: () => import(/* webpackChunkName: "demo" */ '../views/Demo.vue')
  //},

  //{
  // path: '/about',
  // name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  //},
  {
    path: '/reservation',
    name: 'New Reservation',
    component: () => import(/* webpackChunkName: "demo" */ '../views/Reservation.vue'),
    meta: {
      title: 'New Reservation'
    }
  },
  {
    path: '/booking',
    name: 'Booking Details',
    component: () => import(/* webpackChunkName: "demo" */ '../views/Booking'),
    meta: {
      title: 'Booking Details'
    }
  },
  {
    path: '/confirmation',
    name: 'Reservation Confirmation',
    component: () => import(/* webpackChunkName: "demo" */ '../views/Confirmation'),
    meta: {
      title: 'Reservation Confirmation'
    }
  },
  {
    path: '/orders/view',
    name: 'Reservation View',
    component: () => import(/* webpackChunkName: "demo" */ '../views/orders/View.vue'),
    meta: {
      title: 'Reservation View'
    }
  },
  {
    path: '/orders/search',
    name: 'Reservation Search',
    component: () => import(/* webpackChunkName: "demo" */ '../views/orders/Search.vue'),
    meta: {
      title: 'Reservation Search'
    }
  },
  {
    path: '/404',
    name: 'Page not found',
    component: () => import(/* webpackChunkName: "demo" */ '../views/Error.vue'),
    meta: {
      title: 'Page not found'
    }
  },
  {
    path: '/Terms&Conditions',
    name: 'Terms and Conditions',
    component: () => import(/* webpackChunkName: "demo" */ '../views/TermsConditions.vue'),
    meta: {
      title: 'Terms and Conditions'
    }
  },
  {
    path: '/PrivacyPolicies',
    name: 'Privacy Policies',
    component: () => import(/* webpackChunkName: "demo" */ '../views/PrivacyPolicies.vue'),
    meta: {
      title: 'Privacy Policies'
    }
  },
  {
    name: "refresh",
    path: "/refresh",
    component: () => import('../views/Refresh.vue')
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

router.beforeEach((to, from, next) => {
  const userInfo = util.getCookie('userInfo')
  if (util.getCookie('Authorization') && (userInfo)) {
    if (!JSON.parse(userInfo).pwd_at) {
      if (to.name !== 'Reset') {
        next({path: '/reset'})
      }
    } else {
      if (to.name === 'Home') {
        next({path: '/reservation'})
      }
    }
  }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('/404');
  } else {
    next(); //如果匹配到正确跳转
  }
})

export default router
